<template>
	<div class="cc-wrap-content">
		<div class="sd-divider"></div>
		<div class="sd-content-section">
			<a id="clientSecurity"></a>
			<h3 class="sd-title-right" v-html="translations.ccClientSecurityTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content-full">
					<p v-html="translations.ccClientSecurityContent"></p>
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="configuration"></a>
			<h3 class="sd-title-left" v-html="translations.ccClientConfigTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content-half">
					<p v-html="translations.ccClientConfigContent1"></p>
					<p v-html="translations.ccClientConfigContent2"></p>
				</div>
				<div class="sd-img-half sd-img-right ">
					<Slideshow :images="configImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="visualization"></a>
			<h3 class="sd-title-right" v-html="translations.ccClientVisualizationTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-img-half sd-img-left sd-horizontal">
					<Slideshow :images="visImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
				<div class="sd-content-half">
					<p v-html="translations.ccClientVisualizationContent1"></p>
					<p v-html="translations.ccClientVisualizationContent2"></p>
					<p v-html="translations.ccClientVisualizationContent3"></p>
					<p v-html="translations.ccClientVisualizationContent4"></p>
					<p v-html="translations.ccClientVisualizationContent5"></p>
				</div>
				<div class="sd-img-half sd-img-right sd-vertical">
					<Slideshow :images="visImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="physicianTalk"></a>
			<h3 class="sd-title-left" v-html="translations.ccClientPractitionerTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content-full">
					<p v-html="translations.ccClientPractitionerContent"></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Slideshow from './Slideshow.vue';
import i18n from '@/translations/i18n';
export default {
	name: 'ClientContent',
	components: {
		Slideshow,
	},
	data() {
		return {
			configImages: [
				{ src: 'ClientProfileScreen.png', alt: this.$t('ccClientProfileAlt') },
				{ src: 'ClientPatientCreationScreen.png', alt: this.$t('ccClientPatientCreationAlt') },
				{ src: 'ClientCaseCreationScreen1.png', alt: this.$t('ccClientCaseCreationAlt1') },
				{ src: 'ClientCaseCreationScreen2.png', alt: this.$t('ccClientCaseCreationAlt2') },
				{ src: 'ClientQuestionnaireCreationScreen.png', alt: this.$t('ccClientQuestionnaireCreationAlt') },
				{ src: 'ClientAuthScreen.png', alt: this.$t('ccClientAuthAlt') },
			],
			visImages: [
				{ src: 'ClientQueryScreen.png', alt: this.$t('ccClientQueryAlt') },
				{ src: 'ClientVisScreen1.png', alt: this.$t('ccClientVisAlt1') },
				{ src: 'ClientVisScreen2.png', alt: this.$t('ccClientVisAlt2') },
				{ src: 'ClientVisScreen3.png', alt: this.$t('ccClientVisAlt3') },
				{ src: 'ClientVisScreen4.png', alt: this.$t('ccClientVisAlt4') },
				{ src: 'ClientVisScreen5.png', alt: this.$t('ccClientVisAlt5') },
				{ src: 'ClientVisScreen6.png', alt: this.$t('ccClientVisAlt6') },
			],
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				ccClientSecurityTitle: this.$t('ccClientSecurityTitle'),
				ccClientSecurityContent: this.$t('ccClientSecurityContent'),
				ccClientConfigTitle: this.$t('ccClientConfigTitle'),
				ccClientConfigContent1: this.$t('ccClientConfigContent1'),
				ccClientConfigContent2: this.$t('ccClientConfigContent2'),
				ccClientVisualizationTitle: this.$t('ccClientVisualizationTitle'),
				ccClientVisualizationContent1: this.$t('ccClientVisualizationContent1'),
				ccClientVisualizationContent2: this.$t('ccClientVisualizationContent2'),
				ccClientVisualizationContent3: this.$t('ccClientVisualizationContent3'),
				ccClientVisualizationContent4: this.$t('ccClientVisualizationContent4'),
				ccClientVisualizationContent5: this.$t('ccClientVisualizationContent5'),
				ccClientPractitionerTitle: this.$t('ccClientPractitionerTitle'),
				ccClientPractitionerContent: this.$t('ccClientPractitionerContent'),
			};
		},
	},
	created() {
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
	},
};
</script>

<style scoped>
.cc-wrap-content {
	width: 100%;
	margin: auto;
}

.cc-wrap-content h3 {
	margin: 35px 100px;
}
</style>
